import { Flex } from "@chakra-ui/react";
import { BlockHeader } from "../BlockHeader";
import * as React from "react";

function ScopeHeader({ title, description}) {
  return (
    <Flex flexDir="column" paddingBlock="6">
      <BlockHeader title={title} description={description} />
    </Flex>
  );
}

export default ScopeHeader;
